// extracted by mini-css-extract-plugin
export default {"title":"aM5Zae"};